/* The Damga mark as a component. The geometry lives in ./mark-geometry.js, which is the
 * single source for this, the icon generator and the standalone vector; see
 * that file for the unit spec and for why the counter is a real knockout.
 *
 * Takes `currentColor`, so it is coloured by the token on whatever contains it
 * rather than carrying a hex of its own.
 */
import { markPath } from "./mark-geometry";

export function Mark({ size = 24, title }: { size?: number; title?: string }) {
  return (
    <svg
      viewBox="0 0 1000 1000"
      width={size}
      height={size}
      role={title ? "img" : "presentation"}
      aria-label={title}
      aria-hidden={title ? undefined : true}
      focusable="false"
    >
      <path fill="currentColor" fillRule="evenodd" d={markPath()} />
    </svg>
  );
}

/* The wordmark is IBM Plex Sans 600, tracked -0.03em, sentence case. Never all
 * caps, never the mono face. Set as text rather than drawn, so it renders in
 * the real face at every size. */
export function Wordmark({ size = 18 }: { size?: number }) {
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: size * 0.42,
        color: "var(--ink)",
      }}
    >
      <Mark size={size} title="Damga" />
      <span
        style={{
          fontFamily: "var(--font-sans)",
          fontWeight: 600,
          fontSize: size,
          letterSpacing: "-0.03em",
          lineHeight: 1,
        }}
      >
        Damga
      </span>
    </span>
  );
}
